module.exports = __webpack_public_path__ + "static/media/JH.02d4f21b.svg";